import { ApolloClient } from '@apollo/client';

import { Club_Id_From_Old_IdDocument } from '../pages/_internal/IdResolver.query.generated';

const convertToUUID = (oldId: string): string => {
  // Ensure the ID is padded to 32 characters
  const paddedId = oldId.padStart(32, '0');
  // Format as UUID: 00000000-5b93-8ab5-0c1e8b04c15693d8
  return `${paddedId.slice(0, 8)}-${paddedId.slice(8, 12)}-${paddedId.slice(12, 16)}-${paddedId.slice(16)}`;
};

// Pour les widgets MonSiteClub avec l'ancien ID
export const resolveClubId = async (
  clubId: string | string[] | undefined,
  client: ApolloClient
): Promise<number> => {
  if (!clubId) {
    throw new Error('Club ID is required');
  }

  const id = Array.isArray(clubId) ? clubId[0] : clubId;

  // Si l'ID est un nombre, on le retourne directement
  if (!isNaN(Number(id))) {
    return Number(id);
  }

  // Sinon, on convertit d'abord en format UUID
  const uuidId = convertToUUID(id);

  // Puis on fait une requête pour obtenir l'ID à partir de l'ancien ID
  try {
    const { data } = await client.query({
      query: Club_Id_From_Old_IdDocument,
      variables: {
        old_scorenco_id: uuidId,
      },
      context: {
        role: 'anonymous',
      },
    });

    const id = data?.clubs_club?.[0]?.id;
    if (!id) {
      throw new Error('Club not found');
    }

    return id;
  } catch (error) {
    console.error('Error resolving club ID:', error);
    throw new Error('Failed to resolve club ID');
  }
};
